import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';

import { post } from '../../api/api';

export const createMergeEmployee = (
  orgId: number,
  employeeId: number,
  integrationName?: string | null,
) =>
  createGenericDispatcher<Employee>({
    name: 'CREATE_MERGE_EMPLOYEE',
    loadFunction: () =>
      post('/merge/employee', {
        body: JSON.stringify({ orgId, employeeId }),
      }),
    args: { orgId, employeeId },
    onSuccess: (dispatch) => {
      dispatch(
        addNotificationAction({
          key: `create-merge-employee-${employeeId}`,
          message: `Employee successfully created in ${integrationName || 'HR/payroll system'}`,
        }),
      );
    },
  });
